import { CountryCode } from 'libphonenumber-js';

import { CountryConfig, countryConfig } from './countryConfig';

const postalLabel = {
    postcode: 'Postcode',
    zipcode: 'ZIP Code',
    eircode: 'Eircode',
    pin: 'PIN Code',
};

const REGION = (process.env.REGION as CountryCode) ?? 'IE';

const getPostalLabel = (countryCode?: string) => {
    const code = countryCode ?? REGION;
    const config = countryConfig[code] as CountryConfig;
    return postalLabel[config.postalCodeType];
};

export default getPostalLabel;
